var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvalidFieldIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.84475 2.0026C7.35795 1.11372 8.64095 1.11371 9.15415 2.0026L14.9277 12.0026C15.4409 12.8915 14.7994 14.0026 13.773 14.0026H2.22595C1.19955 14.0026 0.558047 12.8915 1.07125 12.0026L6.84475 2.0026ZM7.99945 2.66927L2.22595 12.6693H13.773L7.99945 2.66927Z",
    fill: "#F05353"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29688 10.6667C7.29688 10.2985 7.59535 10 7.96354 10H8.03021C8.3984 10 8.69687 10.2985 8.69687 10.6667V10.7333C8.69687 11.1015 8.3984 11.4 8.03021 11.4H7.96354C7.59535 11.4 7.29688 11.1015 7.29688 10.7333V10.6667Z",
    fill: "#F05353"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0026 5.33594C8.37079 5.33594 8.66927 5.63441 8.66927 6.0026V8.66927C8.66927 9.03746 8.37079 9.33594 8.0026 9.33594C7.63441 9.33594 7.33594 9.03746 7.33594 8.66927V6.0026C7.33594 5.63441 7.63441 5.33594 8.0026 5.33594Z",
    fill: "#F05353"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvalidFieldIndicator);
export default __webpack_public_path__ + "static/media/invalidFieldIndicator.ae406e527b5bbaab293aa53209c1d07b.svg";
export { ForwardRef as ReactComponent };